/**
 * Virtual Account API
 * 가상계좌 관련 API 호출
 */
import { apiClient } from '@/shared/api/client';
import { VirtualAccountListResponse } from '../types/virtualAccount.types';

export const virtualAccountApi = {
    /**
     * 가상계좌 전체 목록 조회
     */
    getVirtualAccounts: async (page = 0, size = 10): Promise<VirtualAccountListResponse> => {
        const response = await apiClient.get('/api/v1/virtual-account', { params: { page, size } });
        return response.data;
    },

    /**
     * 협력사 ID로 가상계좌 조회
     */
    getVirtualAccountBySuppId: async (suppId: string) => {
        const response = await apiClient.get(`/api/v1/virtual-account/supplier/${suppId}`);
        return response.data;
    },

    /**
     * 라이더 ID로 가상계좌 조회
     */
    getVirtualAccountByRiderId: async (riderId: string) => {
        const response = await apiClient.get(`/api/v1/virtual-account/rider/${riderId}`);
        return response.data;
    },
};
